// src/store/transito/index.ts
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

export interface TransitoFilters {
  barra?: string;
  codprod?: string;
  codprove?: string;
  tipedido?: string;
  date_from?: string; // YYYY-MM-DD
  date_to?: string; // YYYY-MM-DD
  per_page?: number;
  page?: number;
}

export interface TransitoRow {
  item: number;
  id: number;
  codprod: string;
  desprod: string;
  cantidad: number;
  barra: string;
  codprove: string;
  tipedido: string;
  dias_transito: number;
  fecha: string;
  fecenviado: string;
  codcli: string;
  marca: string;
}

/**
 * Payload para DELETE /api/transito/destroy
 * Soporta:
 * - { item: 123 }
 * - { items: [1,2,3] }
 * - { id: 55, cerrar: true }  (cierra/borrar pedido completo)
 */
export type TransitoDestroyPayload =
  | { item: number }
  | { items: number[] }
  | { id: number; cerrar: true };

export interface TransitoState {
  transitoData: TransitoRow[];

  next_page_url: string | null;
  prev_page_url: string | null;
  first_page_url: string | null;
  last_page_url: string | null;

  last_page: number;
  current_page: number;
  total: number;
  from: number | null;
  to: number | null;

  loading: boolean;
  isLoadingMore: boolean;
  errorMessage: string | null;

  selectedFilters: TransitoFilters;
}

const state: TransitoState = {
  transitoData: [],

  next_page_url: null,
  prev_page_url: null,
  first_page_url: null,
  last_page_url: null,

  last_page: 1,
  current_page: 1,
  total: 0,
  from: null,
  to: null,

  loading: false,
  isLoadingMore: false,
  errorMessage: null,

  selectedFilters: {
    per_page: 25,
    page: 1,
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};